import React from "react";
import useMediaQuery from "./useMediaQuery";

const MONO = "ui-monospace, SF Mono, Menlo, Fira Code, monospace";

export default function StatCard({ label, value, detail, accent = "#00ADB5", actionLabel, onClick }) {
  const isMobile = useMediaQuery("(max-width: 640px)");

  return (
    <div
      onClick={onClick}
      style={{
        background: "linear-gradient(180deg, rgba(255,255,255,0.025), transparent)",
        border: "1px solid rgba(255,255,255,0.06)",
        borderTop: `3px solid ${accent}`,
        borderRadius: 14,
        padding: isMobile ? "14px 15px" : "18px 20px",
        cursor: onClick ? "pointer" : "default",
        boxShadow: "0 14px 30px -24px rgba(0,0,0,0.6)",
      }}
    >
      <div style={{ fontSize: 10.5, fontWeight: 800, letterSpacing: "0.09em", color: "#c3c8cc" }}>
        {label}
      </div>
      <div
        style={{
          display: "flex",
          alignItems: "baseline",
          justifyContent: "space-between",
          gap: 8,
          marginTop: 8,
        }}
      >
        <span style={{ fontFamily: MONO, fontSize: isMobile ? 21 : 25, fontWeight: 700, color: "#fff", minWidth: 0, overflowWrap: "anywhere" }}>
          {value}
        </span>
        {actionLabel && (
          <span style={{ fontSize: 12, fontWeight: 600, color: accent, whiteSpace: "nowrap" }}>
            {actionLabel}
          </span>
        )}
      </div>
      {detail && <div style={{ fontSize: 11, color: "#c3c8cc", marginTop: 4 }}>{detail}</div>}
    </div>
  );
}
